import { type UseQueryResult, useQuery } from 'react-query';
import { PerformanceRuleService } from '../../services/wealthlane-award-services';

const useGetPerformanceRuleApprovalStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const PerformanceRuleApprovalStatus = useQuery(
    ['getPerformanceRuleApprovalStatus'],
    async () => {
      return await handleRequest(
        PerformanceRuleService.getApiAwardApiAppPerformanceRuleRuleApprovalStatusList()
      );
    },
    {
      select: (data) => {
        const options = data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });

        // const sortOptions = options?.concat({ label: 'All', value: 0 }).sort(function (a, b) {
        //   return a.label.localeCompare(b.label);
        // });
        return options;
      },
    }
  );

  return PerformanceRuleApprovalStatus;
};

export default useGetPerformanceRuleApprovalStatus;
